import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Header } from "../../../components/header";
import { SendIcon } from "../../../components/icons";
import { parseSearchParams } from "../../../helpers/clean-object";

import { CategoryForm } from "../components";
import { useCreateCategory } from "../hooks";

export const CreateCategory: React.FC = () => {
  const [params] = useSearchParams();

  const { form, submit, loading } = useCreateCategory({
    defaultValues: {
      ...parseSearchParams(params),
    },
    onCompleted: () => toast.success("Le demande a été créé avec succès"),
    onError: (msg) => toast.error(msg),
  });

  return (
    <>
      <Header
        title="Categorie"
        subtitle="Ajouter une nouvelle categorie"
        buttons={[
          {
            actionText: "Annuler",
            bgColor: "indigo",
            textColor: "white",
            link: "/categories",
            icon: <SendIcon />,
          },
        ]}
      />
      <div className="main-container">
        <CategoryForm loading={loading} submit={submit} form={form} />
      </div>
    </>
  );
};
